/* Veepunzel – kleine Ergänzungen:
   1. Steuerhinweis für die Kleinunternehmerregelung (Produktseite UND Warenkorb)
   2. Versand-Fortschritt im Warenkorb – kennt das Gratis-Profil der Gefühlsbegleiter
   3. variantengenaue Thumbnails in der Produktgalerie
   4. Gefühlsname als Untertitel in der Fine-Art-Galerie + korrekte Motiv-Übergabe in den Warenkorb
   5. Warenkorb-Bild der 50 Fine-Art-Einzelmotive: zeigt das tatsächlich gewählte Motiv
      statt des generischen Produktbilds (siehe fixCartImages weiter unten) */
(function () {
  var THRESHOLD = 3900; // 39,00 € in Cent – muss zur Versandregel im Admin passen
  var FREE_HANDLE = 'gefuhlsbegleiter'; // eigenes Versandprofil, immer gratis
  var TAX_PRODUCT = 'Kein Ausweis der Umsatzsteuer gemäß § 19 UStG. Versandkosten werden im Checkout berechnet.';
  var TAX_CART = 'Kein Ausweis der Umsatzsteuer gemäß § 19 UStG. Rabatte und Versand werden im Checkout berechnet.';

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function taxNote() {
    document.querySelectorAll('.product__tax').forEach(function (el) {
      if (el.dataset.vpDone) return;
      el.dataset.vpDone = '1';
      el.innerHTML = TAX_PRODUCT;
    });
    document.querySelectorAll('.tax-note').forEach(function (el) {
      if (el.dataset.vpDone) return;
      el.dataset.vpDone = '1';
      el.innerHTML = TAX_CART;
    });
  }

  /* Studio verschachtelt .cart-drawer__footer und .drawer__footer ineinander –
     nur den innersten Treffer befüllen, sonst steht der Hinweis doppelt da. */
  function shipHosts() {
    var all = Array.prototype.slice.call(document.querySelectorAll(
      'cart-drawer .drawer__footer, .cart-drawer__footer, .cart__footer, #main-cart-footer'
    ));
    return all.filter(function (h) {
      return !all.some(function (o) { return o !== h && h.contains(o); });
    });
  }

  function renderShip(host, msg, cls) {
    var n = host.querySelector('.vp-ship-progress');
    if (!msg) { if (n) n.remove(); return; }
    if (!n) { n = document.createElement('p'); n.className = 'vp-ship-progress'; host.prepend(n); }
    if (n.textContent !== msg) n.textContent = msg;
    var full = 'vp-ship-progress' + cls;
    if (n.className !== full) n.className = full;
  }

  /* Die Gefühlsbegleiter haben ein eigenes Versandprofil und sind immer
     gratis – sie zählen deshalb NICHT auf die 39-€-Schwelle der übrigen
     Artikel. Shopify rechnet die Schwelle pro Profil, wir hier genauso. */
  function shipProgress() {
    var hosts = shipHosts();
    if (!hosts.length) return;
    document.querySelectorAll('.vp-ship-progress').forEach(function (n) {
      if (hosts.indexOf(n.parentElement) === -1) n.remove();
    });
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var msg, cls;
        var rest = (cart.items || []).filter(function (i) { return i.handle !== FREE_HANDLE; });
        var restTotal = rest.reduce(function (s, i) { return s + i.final_line_price; }, 0);
        if (cart.item_count === 0) { msg = ''; cls = ''; }
        else if (rest.length === 0) { msg = 'Versandkostenfrei – Gefühlsbegleiter reisen gratis.'; cls = ' vp-ship--done'; }
        else if (restTotal >= THRESHOLD) { msg = 'Versandkostenfrei – geschafft.'; cls = ' vp-ship--done'; }
        else { msg = 'Noch ' + euro(THRESHOLD - restTotal) + ' bis zum kostenlosen Versand.'; cls = ''; }
        hosts.forEach(function (h) { renderShip(h, msg, cls); });
      })
      .catch(function () {});
  }

  function watchCart() {
    document.querySelectorAll('cart-drawer, #main-cart-footer, cart-items').forEach(function (t) {
      if (t.dataset.vpWatched) return;
      t.dataset.vpWatched = '1';
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { taxNote(); shipProgress(); fixCartImages(); }, 250);
      }).observe(t, { childList: true, subtree: true });
    });
  }

  function syncThumbnails(root, html) {
    var gallery = root.querySelector('media-gallery');
    if (!gallery) return;
    var thumbs = gallery.querySelector('.thumbnail-list');
    var fresh = html.querySelector('media-gallery .thumbnail-list');
    if (!thumbs || !fresh) return;
    if (thumbs.innerHTML.trim() === fresh.innerHTML.trim()) return;
    thumbs.innerHTML = fresh.innerHTML;
    thumbs.querySelectorAll('[data-target]').forEach(function (item) {
      var btn = item.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', gallery.setActiveMedia.bind(gallery, item.dataset.target, false));
    });
    var total = html.querySelector('media-gallery .slider-counter--total');
    var liveTotal = gallery.querySelector('.slider-counter--total');
    if (total && liveTotal) liveTotal.textContent = total.textContent;
  }

  function patchProductInfo() {
    var C = window.customElements && customElements.get('product-info');
    if (!C || !C.prototype || C.prototype.__vpThumbPatch) return;
    var original = C.prototype.updateMedia;
    if (typeof original !== 'function') return;
    C.prototype.__vpThumbPatch = true;
    C.prototype.updateMedia = function (html, variantFeaturedMediaId) {
      try { syncThumbnails(this, html); }
      catch (err) { console.warn('[veepunzel] Thumbnail-Sync fehlgeschlagen', err); }
      return original.call(this, html, variantFeaturedMediaId);
    };
  }

  /* Fine-Art-Galerie: die Bilddateien tragen die Gefühlsnamen. Unter dem
     aktiven Bild zeigen wir den Namen aus dem Alt-Text (alles vor dem
     ersten Gedankenstrich) – so findet man sein Motiv beim Durchklicken.
     Zusätzlich wird bei "Gefühle einzeln · Fine-Art-Print" das gerade
     sichtbare Motiv in ein verstecktes Formularfeld (properties[Motiv])
     geschrieben, das außerhalb des Formulars liegt, aber per form="..."
     trotzdem mit übermittelt wird (siehe product-media-gallery.liquid) –
     sonst würde beim "In den Warenkorb" nie feststehen, welches der 50
     Motive gemeint war, weil die Galerie keine Shopify-Variante ist.

     Auf dem Handy gibt es keine Thumbnails zum Anklicken (Dawn blendet sie
     unter der Mobil-Breite aus) – dort wird nur noch das Hauptbild gewischt.
     Ein reines Wischen/Scrollen löst weder einen Klick noch zuverlässig eine
     Änderung an class/aria-current aus. Statt uns auf einen IntersectionObserver
     mit einem Nicht-Dokument-Root zu verlassen (auf manchen Mobilbrowsern
     unzuverlässig), bestimmen wir bei jedem nativen Scroll-Event direkt
     geometrisch (getBoundingClientRect), welches Bild gerade in der Mitte
     des sichtbaren Bereichs liegt – das funktioniert unabhängig davon, ob
     per Klick, Pfeil-Buttons oder Wischgeste navigiert wurde. */
  var CAPTION_PAGES = /gefuehle-einzeln-fine-art-print|fine-art-print-ubersichtsposter/;
  function galleryCaption() {
    if (!CAPTION_PAGES.test(location.pathname)) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var cap = gallery.querySelector('.vp-galcap');
    if (cap) return; // schon eingerichtet

    cap = document.createElement('p');
    cap.className = 'vp-galcap';
    var viewer = gallery.querySelector('slider-component');
    if (viewer && viewer.parentNode) viewer.parentNode.insertBefore(cap, viewer.nextSibling);
    else gallery.appendChild(cap);

    var motivInput = document.querySelector('.vp-motiv-input');

    function setNameFromImg(img) {
      if (!img) return;
      var name = (img.alt || '').split('–')[0].trim();
      if (!name) return;
      if (cap.textContent !== name) cap.textContent = name;
      if (motivInput && motivInput.value !== name) motivInput.value = name;
    }

    function currentItem() {
      return gallery.querySelector('.product__media-item.is-active') ||
             gallery.querySelector('.product__media-item');
    }

    function updateFromCurrent() {
      var item = currentItem();
      setNameFromImg(item && item.querySelector('img'));
    }

    // Klick auf ein Thumbnail oder die Pfeil-Buttons (Desktop/Tablet)
    gallery.addEventListener('click', function () { setTimeout(updateFromCurrent, 150); });

    // Aktive Klasse ändert sich, z. B. nach einem Thumbnail-Klick
    new MutationObserver(function () { setTimeout(updateFromCurrent, 100); })
      .observe(gallery, { attributes: true, attributeFilter: ['class', 'aria-current'], subtree: true });

    // Wischen auf dem Handy: der Slider scrollt nativ. Bei jedem Scroll
    // (rAF-gedrosselt) direkt geometrisch bestimmen, welches Bild gerade
    // in der Mitte des sichtbaren Bereichs liegt – robuster als
    // IntersectionObserver mit einem nicht-Dokument-Root.
    var track = gallery.querySelector('.product__media-list') || gallery.querySelector('ul[id^="Slider-Gallery"]');
    if (track) {
      var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));

      function findCentered() {
        if (!items.length) return null;
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + trackRect.width / 2;
        var closest = null;
        var closestDist = Infinity;
        items.forEach(function (item) {
          var r = item.getBoundingClientRect();
          if (r.width === 0) return;
          var itemCenter = r.left + r.width / 2;
          var dist = Math.abs(itemCenter - center);
          if (dist < closestDist) { closestDist = dist; closest = item; }
        });
        return closest;
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        (window.requestAnimationFrame || function (fn) { setTimeout(fn, 50); })(function () {
          ticking = false;
          var item = findCentered();
          setNameFromImg(item && item.querySelector('img'));
        });
      }
      track.addEventListener('scroll', onScroll, { passive: true });
      // Auch nach Layout-Änderungen (z. B. Bilder nachträglich geladen)
      // einmal neu ausrichten, falls sich die Zentrierung dadurch verschiebt.
      window.addEventListener('resize', onScroll, { passive: true });
    }

    updateFromCurrent();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-info').then(patchProductInfo).catch(function () {});
  }
  patchProductInfo();

  /* Warenkorb-Bild der 50 Fine-Art-Einzelmotive: die Motive sind keine
     Shopify-Varianten (siehe galleryCaption oben), deshalb zeigt der
     Warenkorb von Haus aus immer nur das generische Hauptbild des
     Produkts – unabhängig davon, welches der 50 Motive tatsächlich im
     Warenkorb liegt (das gewählte Motiv steckt nur in der Bestellposition-
     Eigenschaft properties[Motiv]). Wir holen uns einmal die Medienliste
     des Produkts per JSON-Endpunkt, suchen darin das Bild, dessen Alt-Text
     mit dem Motivnamen beginnt, und ersetzen damit das im Warenkorb
     angezeigte Bild – für jede Zeile einzeln. */
  var MOTIV_HANDLE = 'gefuehle-einzeln-fine-art-print';
  var motivMediaPromise = null;

  function loadMotivMedia() {
    if (motivMediaPromise) return motivMediaPromise;
    motivMediaPromise = fetch('/products/' + MOTIV_HANDLE + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        return (p.media || []).map(function (m) {
          var src = m.src || (m.preview_image && m.preview_image.src) || '';
          return { src: src, alt: (m.alt || '').split('–')[0].trim() };
        }).filter(function (m) { return m.src; });
      })
      .catch(function () { return []; });
    return motivMediaPromise;
  }

  function widthUrl(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function fixCartImages() {
    loadMotivMedia().then(function (media) {
      if (!media.length) return;
      var dts = document.querySelectorAll('dt');
      dts.forEach(function (dt) {
        if (!/^Motiv\s*:?$/.test((dt.textContent || '').trim())) return;
        var dd = dt.nextElementSibling;
        if (!dd) return;
        var motiv = dd.textContent.trim();
        if (!motiv) return;
        var hit = media.filter(function (m) { return m.alt === motiv; })[0];
        if (!hit) return;
        var row = dt.closest('cart-item, .cart-item, [class*="cart-item"], tr, li') || dt.parentElement;
        if (!row) return;
        var img = row.querySelector('img');
        if (!img) return;
        var resized = widthUrl(hit.src, 200);
        if (img.dataset.vpMotivImg === resized) return;
        img.dataset.vpMotivImg = resized;
        img.src = resized;
        img.removeAttribute('srcset');
      });
    });
  }

  function run() { taxNote(); shipProgress(); patchProductInfo(); watchCart(); galleryCaption(); fixCartImages(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  document.addEventListener('cart:refresh', run);
  document.addEventListener('click', function (e) {
    if (e.target.closest('form[action*="/cart"] button, .quantity__button, cart-remove-button, .cart-drawer, cart-drawer')) {
      setTimeout(run, 400);
      setTimeout(run, 1200);
    }
  });
  new MutationObserver(function () { taxNote(); watchCart(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
